import {IconButton, SxProps} from "@mui/material";
import {RefreshIcon} from "./icons";
import {Theme} from "@emotion/react";

const RefreshButton: React.FC<{
  isLoading: boolean;
  sx?: SxProps<Theme>;
  onClick: () => void;
}> = ({isLoading, sx, onClick}) => {
  return (
    <IconButton onClick={onClick} disabled={isLoading} sx={sx}>
      <RefreshIcon fontSize="inherit" />
    </IconButton>
  );
};

export {RefreshButton};
